module.exports = __webpack_public_path__ + "assets/images/9X16ccrD.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wopi-clipped-snap.png
// module id = 159
// module chunks = 0